import Edit from './Edit';
import List from './List';
export { Edit, List };



//////////////////
// WEBPACK FOOTER
// ./src/app/core/constant/index.ts
// module id = 1278
// module chunks = 0